//FUNCIONS
import React from 'react';

//HOOKS
import { menuAccount } from '../hooks/hooksAccount';

//TYPES

//COMPONENTS
import AccountAddress from '../AccountAddress';
import AccountData from '../AccountData';
import AccountOrders from '../AccountOrders';

//STYLES
import {
  Container,
  ContainerBody,
  ContainerLeft,
  ContainerMenu,
  ContainerMenuItem,
  ContainerRight,
} from './styles';
import { AccountPaymentUser } from '../AccountPayment';
import RemoveAccount from '../RemoveAccount';
import { useTranslation } from '../../../hooks/useTranslation';
import { useHistory, useLocation } from 'react-router-dom';
import { routesEndpoints } from '../../../routes/endpoint';

const Account: React.FC = () => {
  const { onTranslation: t } = useTranslation();
  const history = useHistory();
  const location = useLocation();

  return (
    <Container>
      <ContainerBody>
        <ContainerLeft>
          <ContainerMenu>
            {menuAccount.map(menu => (
              <ContainerMenuItem key={menu.id} active={menu.path === location.pathname} onClick={() => history.push(menu.path)} >
                <span>{t(menu.name)}</span>
              </ContainerMenuItem>
            ))}
          </ContainerMenu>
        </ContainerLeft>
        <ContainerRight>
          {location.pathname === routesEndpoints.NEW_ACCOUNT && <AccountData />}
          {location.pathname === routesEndpoints.NEW_ACCOUNT_PAYMENT && <AccountPaymentUser />}
          {location.pathname === routesEndpoints.NEW_ACCOUNT_ADDRESS && <AccountAddress />}
          {location.pathname === routesEndpoints.NEW_ACCOUNT_ORDERS && <AccountOrders />}
          {location.pathname === routesEndpoints.NEW_ACCOUNT_CANCEL && <RemoveAccount />}
        </ContainerRight>
      </ContainerBody>
    </Container>
  );
}

export default Account;
